module.exports = __webpack_public_path__ + "img/dummy-contest-1.d71d85b2.png";